import ArrowIcon from '../../../components/atoms/Arrow'
import Button from '../../../components/atoms/GoodFlipButton'
import InputField from '../../../components/atoms/InputField'
import Text from '../../../components/atoms/Text'
import useAddAddressDetails from '../hooks/useAddAddressDetails'

const AddAddressDetails = ({ onProceed }) => {
  const {
    loading,
    onSubmit,
    register,
    formFields,
    handleSubmit,
    formState: { errors, isValid },
  } = useAddAddressDetails({ onProceed })

  return (
    <div className="px-4 pb-20 pt-4 space-y-5">
      <div className="flex justify-between items-center">
        <Text tag="p" variant="display" size="small">
          Add Address
        </Text>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
        {formFields?.map((field) => (
          <div key={field.name}>
            <InputField
              label={field.label}
              placeholder={field.placeholder}
              type={field.type}
              minLength={field.minLength}
              maxLength={field.maxLength}
              autoFocus={field.focus}
              error={Boolean(errors[field.name]?.message)}
              errorMessage={errors[field.name]?.message}
              {...register(field.name, field.validation)}
            />
          </div>
        ))}

        <div className="fixed max-w-lg lg:max-w-5xl xl:max-w-6xl mx-auto bottom-0 left-0 right-0 bg-WHITE py-4 shadow-lg">
          <Button
            isSubmitButton
            title="Proceed"
            disabled={!isValid || loading}
            loading={loading}
            type="goodflip_primary"
            rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
            leftIcon={null}
          />
        </div>
      </form>
    </div>
  )
}

export default AddAddressDetails
